interface HighlightTextProps {
  text: string;
  highlightedText: string | undefined;
}

export function HighlightText({ text, highlightedText }: HighlightTextProps) {
  if (!highlightedText) return <>{text}</>;

  const safeSearchText = highlightedText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const chunks = text.split(new RegExp(`(${safeSearchText})`, 'gi')).filter(Boolean);

  const segments = chunks.map((chunk, index) => ({
    chunk,
    start: chunks.slice(0, index).reduce((total, part) => total + part.length, 0),
  }));

  return (
    <>
      {segments.map(({ chunk, start }) =>
        chunk.toLowerCase() === highlightedText.toLowerCase() ? (
          <mark key={start} className="bg-highlight text-highlight-foreground">
            {chunk}
          </mark>
        ) : (
          chunk
        ),
      )}
    </>
  );
}
